define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 文字、图标的缩放方式。
     *
     * @exports EnumZoomMode
     * 
     * @see IconSymbol#zoomMode
     * @see TextSymbol#zoomMode
     */
    var EnumZoomMode = {
        /**
         * 随相机远近变化。
         * @type {Number}
         * @constant
         */
        CAMERA: 0,

        /**
         * 占屏幕固定像素，即相机远近不影响其可视大小。
         * @type {Number}
         * @constant
         */
        FIX: 1,

        /**
         * 不超过上限值时，占屏幕固定像素；超过上限值时，随相机远近变化。
         * @type {Number}
         * @constant
         */
        MIX: 2
    }
    freezeObject(EnumZoomMode)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {Number} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumZoomMode) {
            if (EnumZoomMode.hasOwnProperty(key) && EnumZoomMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        CAMERA: 0,
        FIX: 1,
        MIX: 2,
        getName: getName
    }
})